export const ADD_PUBLIC_OR_ETF_DIALOG_TITLE = 'Add Public Company / Exchange Traded Fund';
export const ADD_COMP_OR_ETF_BUTTON_LABEL = 'Add Comparable Company/ETF';
